const inivitations = {
  REQUEST_INVITATIONS: 'REQUEST_INVITATIONS',
  RECIEVE_INVITATIONS: 'RECIEVE_INVITATIONS',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  CLEAR_ERRORS: 'CLEAR_ERRORS'
}

export default inivitations;


// WEBPACK FOOTER //
// src/routes/Invitations/actions/actionTypes.js